import { GridRenderEditCellParams, GridValidRowModel } from '@mui/x-data-grid-pro';
import { FunctionComponent } from 'react';

import { RenderEditCellType } from '~/components/DataGridCustom/DataGridCustom.types';

export const editCellFactory = <R extends GridValidRowModel = any, V = any, AdditionalProps = any>(
  Component: FunctionComponent<GridRenderEditCellParams<R, V> & AdditionalProps>,
  additionalProps?: AdditionalProps,
): RenderEditCellType<R, V> => {
  return (params) => {
    return <Component {...params} {...additionalProps} />;
  };
};
